import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "./common/Button";
import useBrandTranslation from "../hooks/useBrandTranslation";

export default function SubscriptionSuccess() {
  const { t } = useBrandTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simular carga y luego redirigir al perfil
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleGoToProfile = () => {
    navigate("/profile?tab=subscription");
    // Recargar la página para que se actualice la suscripción
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  return (
    <main className="flex min-h-screen flex-col items-center justify-center p-4 md:p-24">
      <div className="max-w-md w-full text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-green-600 mb-4">
            {t("app.subscriptionSuccess.title", "¡Suscripción Creada Exitosamente!")}
          </h1>
          <p className="text-lg text-gray-700 mb-4">
            {t(
              "app.subscriptionSuccess.body",
              "Tu suscripción ha sido configurada correctamente. Los pagos se realizarán automáticamente según tu ciclo de facturación."
            )}
          </p>
          <p className="text-sm text-gray-600 mb-8">
            {t(
              "app.subscriptionSuccess.hint",
              "Puedes gestionar tu suscripción desde tu perfil en cualquier momento."
            )}
          </p>
        </div>
        <div className="flex gap-4 justify-center">
          <Button onClick={handleGoToProfile} className="px-6 py-3">
            {t("app.subscriptionSuccess.viewSubscription", "Ver Mi Suscripción")}
          </Button>
          <Button
            onClick={() => navigate("/")}
            variant="secondary"
            className="px-6 py-3 border-gray-300 text-gray-700 hover:bg-gray-100 bg-gray-200"
          >
            {t("app.subscriptionSuccess.goHome", "Ir al Inicio")}
          </Button>
        </div>
      </div>
    </main>
  );
}

